import { instance as http } from "@/vendor/axios.js";

export function getUserInfo() {
  return http.post("/user/info");
}
